import React from 'react';
import { Box, Button } from '@mui/material';
import { Link } from 'react-router-dom';
import CustomizedTables from '../../common/Table';
import { deleteArea, listAreas } from './Areas.service';
import { useCountryParam, buildUrlWithCountry } from '../../common/util/useCountryParam';

const AreasList: React.FC = () => {
    const country = useCountryParam();
    const columns: any[] = [
        { key: "label", label: "Area", minWidth: 150 },
    ];

    return (
        <Box sx={{ paddingY: 6, width: '100%' }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <h2>Areas List</h2>

                <Button variant="contained" color="primary" size='small' sx={{
                    backgroundColor: "#10374A",
                    color: "#FFFFFF",
                    "&:hover": {
                        backgroundColor: "#08293D",
                    }, height: '40px'
                }} component={Link} to={buildUrlWithCountry('/addArea', country)}>
                    Add New Area
                </Button>
            </Box>
            <CustomizedTables
                columns={columns}
                listService={listAreas}
                deleteService={deleteArea}
                editLink={'/editArea'}
            />
        </Box>
    );
};

export default AreasList;
